<template>
    <BreadCrumb PageTitle="Liste des devoirs soumis" />
    <MesDevoirs/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import MesDevoirs from "../../components/Devoir/MesDevoirs.vue";

    export default defineComponent({
      name: "MesDevoirsPage",
      components: {
        BreadCrumb,
        MesDevoirs,
      },
    });
  </script>